import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

import { IconComponent } from '../../icon/icon.component';
import { DialogButtonConfigurationEnum } from './models/enums/dialog-button-configuration.enum';
import { GeneralPromptDialogDataModel } from './models/general-prompt-dialog-data.model';

@Component({
    selector: 'arc-general-prompt-dialog',
    templateUrl: './general-prompt-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatIcon,
        IconComponent,
        TranslocoPipe
    ]
})
export class GeneralPromptDialogComponent {
    DialogButtonConfigurationEnum = DialogButtonConfigurationEnum;
    readonly data: GeneralPromptDialogDataModel = inject(MAT_DIALOG_DATA);
}
